import React, { useState, useEffect } from "react";

const MultiSelectDropDownReset = ({
  data = [],
  handleCheckboxChange,
  toggleDropDown,
  dropdownContainer,
  title,
  filterName,
  selectedDropdownData = [],
}) => {
  const [titleVal, setTitleVal] = useState(title);

  useEffect(() => {
    if (selectedDropdownData.length) {
      setTitleVal(`${selectedDropdownData.length} selected`);
    } else {
      setTitleVal(title);
    }
  }, [selectedDropdownData]);

  return (
    <div className="form-group">
      <div className="btn-group">
        <button
          type="button"
          className="multiselect dropdown-toggle btn btn-default"
          data-toggle="dropdown"
          title={titleVal}
          aria-expanded="false"
          onClick={(e) => toggleDropDown(dropdownContainer, e)}
        >
          <span className="multiselect-selected-text">{titleVal}</span>
          <b className="caret"></b>
        </button>
        <ul
          className="multiselect-container dropdown-menu"
          ref={dropdownContainer}
        >
          {data.length ? (
            <li className="multiselect-item">
              <a href="/#" tabIndex="0" className="multiselect-all">
                <label className="checkbox dropdown-label">
                  <input
                    type="checkbox"
                    value="multiselect-all"
                    name="selectall"
                    onChange={(e) => handleCheckboxChange(e, filterName)}
                    checked={selectedDropdownData.length === data.length}
                  />
                  Select all
                </label>
              </a>
            </li>
          ) : (
            ""
          )}
          {data.map((val, index) => {
            return (
              <li className="multiselect-item-indiv" key={index}>
                <a href="/#" tabIndex="0" id="multiselect-item-anchor">
                  {val.group ? (
                    <b
                      style={{
                        fontSize: "15px",
                        marginLeft: "10px",
                      }}
                    >
                      {val.label}
                    </b>
                  ) : (
                    <label className="checkbox dropdown-label">
                      <input
                        type="checkbox"
                        value={parseInt(val.value)}
                        name={val.label}
                        checked={selectedDropdownData.includes(
                          parseInt(val.value)
                        )}
                        onChange={(e) => handleCheckboxChange(e, filterName)}
                      />
                      {val.label}
                    </label>
                  )}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default MultiSelectDropDownReset;
